import React from "react";
import FadeInSection from "../../../Components/FadeInSection";

const DashboardFAQViewMore = ({ data, onClose }) => {
  return (
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
      <div className="w-[0vw] md:w-1/6"></div>
      <div
          className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            FAQ Details
          </h2>
          <div className="border-t border-gray-200 mb-6"></div>
          <div className="flex flex-col space-y-8 flex-grow">
            {/* Flex layout for headers and descriptions */}
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Question
              </p>
              <p className="text-gray-800 w-2/3">{data.question || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Answer</p>
              <p className="text-gray-800 w-2/3">{data.answer || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Status</p>
              <p className="text-gray-800 w-2/3">
                {data.status === 1 ? "Active" : "Inactive"}
              </p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Created By
              </p>
              <p className="text-gray-800 w-2/3">{data.createdby || "--"}</p>
            </div>
          </div>
          <button
            className="self-start px-4 py-2 bg-gray-300 text-black rounded-lg mt-6"
            onClick={() => {
              onClose();
            }}
          >
            Close
          </button>
        </div>
      {/* </FadeInSection> */}
    </div>
  );
};

export default DashboardFAQViewMore;
